/**
 * @generated SignedSource<<068bd6bd8ab96fff5e3b77214590c125>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DescoperTaskStatus = "FAILURE" | "NOT_FOUND" | "PENDING" | "RUNNING" | "SUCCESS" | "%future added value";
export type ScreensTextGenerationInput = {
  brandDescription?: string | null;
  brandId: string;
};
export type useBrandGenerateScreensAsyncMutation$variables = {
  input: ScreensTextGenerationInput;
};
export type useBrandGenerateScreensAsyncMutation$data = {
  readonly startScreensGenerationTask: {
    readonly message: string;
    readonly status: DescoperTaskStatus;
    readonly taskKey: string;
  };
};
export type useBrandGenerateScreensAsyncMutation = {
  response: useBrandGenerateScreensAsyncMutation$data;
  variables: useBrandGenerateScreensAsyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartDescoperTaskResponse",
    "kind": "LinkedField",
    "name": "startScreensGenerationTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBrandGenerateScreensAsyncMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBrandGenerateScreensAsyncMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6bd9fd17cb62f92bd323803c2715f91b",
    "id": null,
    "metadata": {},
    "name": "useBrandGenerateScreensAsyncMutation",
    "operationKind": "mutation",
    "text": "mutation useBrandGenerateScreensAsyncMutation(\n  $input: ScreensTextGenerationInput!\n) {\n  startScreensGenerationTask(input: $input) {\n    taskKey\n    status\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "47467ec930dedf9c24642eeb373f1606";

export default node;
